<div class="top-day-seller">
  @for (track of tracks; track track) {
    <bmcore-track-item-box class="top-day-seller__item" [track]="track" [tracks]="tracks"> </bmcore-track-item-box>
  }
</div>
